<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let type = 'button';
    export let clazz = undefined;
    export let disabled = false;
</script>
<!--------------------------------------------------------------------------------------------------------------------->

<button {type} {disabled} class={clazz} on:click>
    <slot/>
</button>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    button {
        display: block;
        flex-basis: 8rem;
        padding: 2px 1px;
        margin: .5rem;
        border-radius: 6px;
        /*margin-top: 2rem;*/
        /*margin-left: 30px;*/
        cursor: pointer;
        font-weight: bold;
        border: 0 none;
        color: var(--dark-grey);
    }
    button:disabled {
        background-color: var(--light-grey);
        cursor: not-allowed;
    }

    .submit {
        background: var(--dark-grey);
        color: var(--white-color);
    }

    .clear {
        background-color: var(--white-color);
        color: var(--dark-grey);
        border: 1px solid var(--mid-grey);
    }

    .add {
        background-color: var(--light-grey);
    }

    .delete {
        background-color: red;
        color: var(--white-color);
    }

    .menu {
        display: unset;
        flex-basis: unset;
        padding-left: 4px;
        padding-right: 4px;
        background-color: unset;
        color: var(--white-color);
        margin: 0 .5rem;
    }
</style>